import { Dayjs } from 'dayjs';
import { ValueOf, CommonFieldType } from './utils';

import { ProductType } from './product';
import { UserType } from './user';
import { TransactionType, TransactionStatus } from './transaction';

export type ReportFilters = {
  reportType: string;
  filterType: string;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
};
export type ReportFilterKey = keyof ReportFilters;
export type ReportFilterValue = ValueOf<ReportFilters>;

export type ReportType = CommonFieldType & {
  userId?: string;
  user?: UserType;
  type?: TransactionType;
  status?: TransactionStatus;
  userLevel?: string;
  productId?: string;
  product?: ProductType;
  amount: number;
  pricePerUnit?: number;
  unitName?: string;
  currency?: string;
  appointmentDate?: string;
  paidAt?: string;
  fee?: number;
  total?: number;
  branchId?: string;
  note?: string;
  approvedBy?: string;
  creditAmount?: number;
  paymentImageUrl?: string;
};

export enum TransactionReportType {
  ALL = 'ALL',
  // BUY_AND_SELL = 'BUY_AND_SELL',
  TOPUP_AND_WITHDRAW = 'TOPUP_AND_WITHDRAW',
  REDEEM = 'REDEEM',
  LOAN = 'LOAN',
  // POSITION = 'POSITION',
  BUY_POSITION = 'BUY_POSITION',
  SELL_POSITION = 'SELL_POSITION',
  DEPOSIT = 'DEPOSIT',
  DEPOSIT_STOCK_AND_REDEEM_STOCK = 'DEPOSIT_STOCK_AND_REDEEM_STOCK',
}
